import React from 'react'

import { captureException } from '@util/sentry'
import { SmsPage } from '@components/pages/sms/sms_page'
import { getGlobalEntitiesByLocale } from '@cms-service/api'

export default function SmsSpanish({ globalContext }) {
  return <SmsPage globalContext={globalContext} />
}

export async function getStaticProps() {
  const locale = 'es'

  try {
    const globalEntities = await getGlobalEntitiesByLocale(locale)

    return {
      props: {
        globalContext: {
          ...globalEntities,
          slug: '/es/sms',
          locale,
        },
      },
    }
  } catch (error) {
    captureException(error)
    return {
      data: {},
    }
  }
}
